<script setup>
import App from '@/Layouts/App.vue';
</script>

<template>
  <App> Not found </App>
</template>

<style scoped></style>
